import Main from "./components/pages/Main";
import MapPage from "./components/pages/MapPage";

import "./App.css";

function App() {
  return (
    <>
      {/* <Main /> */}
      <MapPage />
    </>
  );
}

export default App;
